import { flushSync } from 'react-dom'
import { useNavigate } from 'react-router'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useNotification } from '../../../../../hooks'
import { isDraftOpenAction, useDraftCreationOpener } from '../../../../Draft'
import { MINIMIZED_MODAL_KEY } from '../../../../Modal'
import {
  getListingProfileLink,
  RentalPortalListingDraftCreateActionSelectModal,
  useRentalPortalListingDraft,
} from '../../../../RentalPortalListing'
import { getIsListingDraftTiming } from '../../RentalPortalListingsForm'
import { RentalPortalListingsFormModal } from '../../RentalPortalListingsFormModal'
import { useRentalPortalListingFormOpener } from '../useRentalPortalListingFormOpener'

export function useCreateRentalPortalListing({ setModal, onClose, onReload }) {
  const navigate = useNavigate()

  const { handleAddSuccessNotification } = useNotification()

  const { draft, draftId, setDraft } = useRentalPortalListingDraft()

  const { openListingForm } = useRentalPortalListingFormOpener()

  function closeModal() {
    setModal(null)
  }

  function handleSuccess(record, timing) {
    setDraft(null, 0)

    flushSync(onClose)

    handleAddSuccessNotification(
      'RentalPortal.ListingFormCreatedNotificationKey'
    )

    if (getIsListingDraftTiming(timing)) {
      onReload?.()
    } else {
      navigate(getListingProfileLink(record.id))
    }
  }

  function openModal({ action, initialValues } = EMPTY_OBJECT) {
    setModal(
      <RentalPortalListingsFormModal
        initialValues={initialValues}
        isDirtyFromOpen={isDraftOpenAction(action)}
        key={draftId}
        onClose={onClose}
        onReload={onReload}
        onSuccess={handleSuccess}
      />
    )
  }

  function handleCreateNew() {
    setDraft(null, 0)
  }

  const openCreation = useDraftCreationOpener({
    DraftPickerModal: RentalPortalListingDraftCreateActionSelectModal,
    closeModal,
    draft,
    draftId,
    minimizeKey: MINIMIZED_MODAL_KEY.RENTAL_PORTAL_LISTING_FORM,
    openModal,
    setModal,
    onCreateNew: handleCreateNew,
  })

  function handleOpenCreation(payload) {
    openListingForm({
      sourceId: draftId,
      onOpen: () => openCreation(payload),
    })
  }

  return {
    handleOpenCreation,
  }
}
